import ServerSettings from "../../../gd/settings/server-settings/server-settings"
import {GlistSkin} from "../../../gd-modules/generic-list/const";

const fieldsConfig = {

    'bg': {
        type            : 'option',
        defaultValue    : 'gray',
        options         : ['gray','white']
    },
    'skinName': {
        type            : 'option',
        defaultValue    : GlistSkin.SKIN_CARDS,
        options         : [GlistSkin.SKIN_CARDS, GlistSkin.SKIN_MODERN]
    }
}

export default class UserSettingsViewsSavedReports extends ServerSettings {

    public bg       : any
    public skinName : any

    constructor(config: any) {

        super(config, fieldsConfig)

        this.bg         = this.initValue('bg')
        this.skinName   = this.initValue('skinName')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'bg')
        this.valueToJson(result, 'skinName')

        return result
    }
}
